import { FC } from 'react';

import { Box, Checkbox, Typography } from '@mui/material';

type DirectorsCheckItemProps = {
    onClick: () => void;
    director: string;
    checked: boolean;
};

export const DirectorsCheckItem: FC<DirectorsCheckItemProps> = ({ onClick, director, checked }) => {
    return (
        <Box display="flex" alignItems="center" onClick={onClick}>
            <Checkbox sx={{ color: '#F18F34' }} checked={checked} />
            <Typography color="#1D1D1B" fontSize="14px" lineHeight="21px" fontWeight="700">
                {director}
            </Typography>
        </Box>
    );
};
